<div *ngIf="showingOnboardingView">

    <h3>Welcome 👋</h3>

    <p>To proceed, we need permission to view your Trello account.</p>

    <p>
        <button (click)="authenticateWithTrello()"
                [disabled]="!authorizeButtonEnabled">
            Authorize Power-Up
        </button>
    </p>
</div>

<div *ngIf="showingSynchronisingView">

    <h3>
        Please wait a few moments while we import your lists and cards for the first time
        <i class="fas fa-spinner fa-spin"></i>
    </h3>
</div>

<div *ngIf="showingErrorView">

    <h3>Sorry, but something isn't working at our end</h3>

    <div class="error system-error">
        <p>
            <i class="icon fad fa-exclamation-triangle"></i>
            We're sorry, but something isn't working at our end, and we couldn't connect
            with your Trello account at this time. Please try again later.
        </p>
    </div>

    <p>
        <button (click)="refreshApplication()">
            Try Again
        </button>
    </p>
</div>
